import * as React from 'react';
import BaseClient from '../../../../models/base-client';
import ClientActionCell from './client-action-cell';

interface Props {
  client: BaseClient;
  isClientAdmin: boolean;
}

/**
 * ClientEntry
 * @function ClientEntry
 */
const ClientEntry = ({ client, isClientAdmin }: Props) => {
  return (
    <tr>
      <td scope="row">{client.name}</td>
      <td>{client.displayName}</td>
      <td>{client.administrator}</td>
      <td>{client.status === true ? 'ACTIVE' : 'INACTIVE'}</td>
      <ClientActionCell client={client} isClientAdmin={isClientAdmin} />
    </tr>
  );
};

export default ClientEntry;
